import { render } from "./DataProtectionStatement.vue?vue&type=template&id=277f6964"
import script from "./DataProtectionStatement.vue?vue&type=script&lang=js"
export * from "./DataProtectionStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__